/* tslint:disable */
export enum WorkspaceItemType {
  FOLDER = 'FOLDER',
  ATTACHMENT = 'ATTACHMENT',

  TREATMENT_HOLDER = 'TREATMENT_HOLDER',
  TREATMENT_HOLDER_VALIDATED = 'TREATMENT_HOLDER_VALIDATED',
  TREATMENT_HOLDER_SNAPSHOT = 'TREATMENT_HOLDER_SNAPSHOT',

  TREATMENT_RESPONSIBLE = 'TREATMENT_RESPONSIBLE',
  TREATMENT_RESPONSIBLE_VALIDATED = 'TREATMENT_RESPONSIBLE_VALIDATED',
  TREATMENT_RESPONSIBLE_SNAPSHOT = 'TREATMENT_RESPONSIBLE_SNAPSHOT',

  TREATMENT_PROJECT = 'TREATMENT_PROJECT',
  TREATMENT_PROJECT_VALIDATED = 'TREATMENT_PROJECT_VALIDATED',
  TREATMENT_PROJECT_SNAPSHOT = 'TREATMENT_PROJECT_SNAPSHOT',

  TREATMENT_SUB_RESPONSIBLE = 'TREATMENT_SUB_RESPONSIBLE',
  TREATMENT_SUB_RESPONSIBLE_VALIDATED = 'TREATMENT_SUB_RESPONSIBLE_VALIDATED',
  TREATMENT_SUB_RESPONSIBLE_SNAPSHOT = 'TREATMENT_SUB_RESPONSIBLE_SNAPSHOT',

  GLOBAL_MEASURE_CHECK = 'GLOBAL_MEASURE_CHECK',
  GLOBAL_MEASURE_CHECK_VALIDATED = 'GLOBAL_MEASURE_CHECK_VALIDATED',
  GLOBAL_MEASURE_CHECK_SNAPSHOT = 'GLOBAL_MEASURE_CHECK_SNAPSHOT',

  APP_ASSESSMENT = 'APP_ASSESSMENT',
  APP_ASSESSMENT_VALIDATED = 'APP_ASSESSMENT_VALIDATED',
  APP_ASSESSMENT_SNAPSHOT = 'APP_ASSESSMENT_SNAPSHOT',

  AI_ASSESSMENT = 'AI_ASSESSMENT',
  AI_ASSESSMENT_VALIDATED = 'AI_ASSESSMENT_VALIDATED',
  AI_ASSESSMENT_SNAPSHOT = 'AI_ASSESSMENT_SNAPSHOT',

  COVID_ASSESSMENT = 'COVID_ASSESSMENT',
  COVID_ASSESSMENT_VALIDATED = 'COVID_ASSESSMENT_VALIDATED',
  COVID_ASSESSMENT_SNAPSHOT = 'COVID_ASSESSMENT_SNAPSHOT',

  DATA_BREACH = 'DATA_BREACH'
}


